import {defineRouting} from 'next-intl/routing'

import {PAGES_ROUTER_FOLDERS} from '../../router-manifest'
import {Locale} from '../constants'

export const routing = defineRouting({
  locales: Object.values(Locale),
  defaultLocale: Locale.en,
  localePrefix: 'as-needed',
  localeDetection: true,
  // The middleware would otherwise advertise all of `locales` as hreflang alternates in a `Link`
  // header on every response, which is wrong for all but the widest content tier: the base customer
  // journey exists in `fullySupportedLocales` only, and some marketing pages are en or en+es. Each
  // page already declares its own set via `generateDefaultAlternates`, matching what `app/sitemap.ts`
  // emits, so the header can only contradict them - and a contradictory hreflang cluster is one
  // Google discards wholesale, taking the correct locales down with the wrong ones.
  alternateLinks: false,
})

export const isPagesRouterPath = (path: string) => {
  const segments = path.split('/').filter(Boolean)
  const topLevelFolder = routing.locales.includes(segments[0] as any) ? segments[1] : segments[0]
  return PAGES_ROUTER_FOLDERS.includes(topLevelFolder)
}
